import { render, staticRenderFns } from "./JobMessagePreview.vue?vue&type=template&id=1b09637f&"
import script from "./JobMessagePreview.vue?vue&type=script&lang=js&"
export * from "./JobMessagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports